import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { setStatePage, setMessage, EXECUTE_ACCTION } from './actions';
import { withloadAsync, withPostPutDeleteAsync } from '../../api';
import { getMessage, generateParametersToUrl } from '../../../helpers/Utils';
import { TypeMessage } from '../../../constants/defaultValues';
// import { logout } from '../../actions';

// ejecutar acción
function* withData({ payload }) {
  const { data, method, URL, token, callback, module, showNotification } =
    payload;
  try {
    let resultParam = null;
    switch (method) {
      case 'GET':
        // ejecutar la consulta de datos
        resultParam = yield call(
          withloadAsync,
          generateParametersToUrl(data),
          token,
          URL
        );
        break;
      default:
        resultParam = yield call(
          withPostPutDeleteAsync,
          data,
          method,
          token,
          URL
        );
        break;
    }
    if (data.statusKey) {
      yield put(
        setStatePage({
          statusKey: data.statusKey,
          values: {
            data: resultParam.data,
          },
        })
      );
    }
    if (typeof callback === 'function') {
      callback(resultParam);
    }
    if (resultParam.success) {
      if (showNotification !== false) {
        yield put(
          setMessage({
            msg: getMessage(resultParam),
            type: TypeMessage.Success,
            module,
          })
        );
      }
    } else {
      const msg = getMessage(resultParam);
      if (msg === 'Token Expidado') {
        // yield put(logout());
      } else if (showNotification !== false) {
        yield put(
          setMessage({
            msg,
            type: TypeMessage.Warning,
            module,
          })
        );
      }
    }
  } catch (error) {
    const msg = getMessage(error);
    if (msg === 'Token Expidado') {
      // yield put(logout());
    } else {
      if (showNotification !== false) {
        yield put(
          setMessage({
            msg,
            type: TypeMessage.Error,
            module,
          })
        );
      }
      if (typeof callback === 'function') {
        callback({ success: false, error });
      }
    }
  }
}

// Mejoramiento sin tanta validaciones estupidas
export function* watchData() {
  yield takeEvery(EXECUTE_ACCTION, withData);
}

export default function* rootSaga() {
  yield all([fork(watchData)]);
}
